import { useState } from 'react';
import cn from 'classnames';
import TraceSidebar from '@/creditflowresearch/ui/components/trace/common/Sidebar/TraceSidebar';
import AssetClasses from '@/creditflowresearch/ui/components/trace/common/AssetClasses';
import TraceTableContainer from '@/creditflowresearch/ui/components/trace/common/TraceTableContainer';
import MissingSomethingModalButton from '@/creditflowresearch/ui/common/components/MissingSomethingModalButton';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import ProductPageHeader from '@/creditflowresearch/ui/common/components/templates/ProductPageHeader/ProductPageHeader';
import {
  TRACE_PAGE_TITLE,
  traceImageCaption,
  traceNoAccessDescription,
  traceNoAccessFeatures,
} from '@/creditflowresearch/ui/components/trace/contants';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import image from '@/creditflowresearch/ui/assets/noAccess/traceNoAccess.webp';

import bondStyles from '@/creditflowresearch/ui/components/bonds/bonds.module.scss';
import styles from '@/creditflowresearch/ui/components/trace/trace.module.scss';
import pageStyles from '@framework/global-styles/page.module.scss';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import productColors from '@/creditflowresearch/ui/common/styles/productColors';

const Trace = () => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false);
  const { checkAccessByUserPlan } = useUserPlanContext();
  const { checkAccessByUserRegions, checkAccessByUserProducts } = usePageFiltersContext();
  const checks = [
    checkAccessByUserPlan(UserPlanType.PRO),
    checkAccessByUserRegions(),
    checkAccessByUserProducts(),
  ];

  const toggleSidebar = () => setSidebarIsOpen((prevIsOpen) => !prevIsOpen);

  const assetClasses = (
    <div className={ cn(
          spacesStyles.pbl,
          pageStyles.pageNavigationLinks,
      ) }
    >
      <AssetClasses />
    </div>
  );

  return (
    <div className={ bondStyles.bondsLayout }>
      <ProductPageHeader
        title="TRACE"
        accessConditions={ [{ checks }] }
        blockingAccessConditions={ [{ checks: [checkAccessByUserPlan(UserPlanType.STARTER)] }] }
        panelBackground={ productColors.gradientProductAbs }
      />
      <CheckUserAccess
        conditions={ [{
          checks,
          fallback: (
            <div className={ styles.mobileHide }>
              { assetClasses }
            </div>
          ),
        }] }
      >
        { assetClasses }
      </CheckUserAccess>

      <CheckUserAccess
        conditions={ [{
          checks,
          fallback: (
            <NoAccessOverlay
              title={ TRACE_PAGE_TITLE }
              features={ traceNoAccessFeatures }
              description={ traceNoAccessDescription }
              imageCaption={ traceImageCaption }
              image={ image.src }
              isDoubleImage
            />
          ),
        }] }
      >
        <>
          <TraceTableContainer onFiltersClick={ toggleSidebar } />
          <TraceSidebar
            isOpen={ sidebarIsOpen }
            onSidebarToggle={ toggleSidebar }
          />
        </>
      </CheckUserAccess>
      <MissingSomethingModalButton className={ cn(spacesStyles.ptxl, spacesStyles.pbxl) } />
    </div>
  );
};

export default Trace;
